import { render } from "./TheAdminResources.vue?vue&type=template&id=3beb31fe&scoped=true&ts=true"
import script from "./TheAdminResources.vue?vue&type=script&lang=ts"
export * from "./TheAdminResources.vue?vue&type=script&lang=ts"

import "./TheAdminResources.vue?vue&type=style&index=0&id=3beb31fe&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3beb31fe"]])

export default __exports__